module.exports = __webpack_public_path__ + "img/65C.5375bd6c.png";